export const ACCESSES_REQUEST = "ACCESSES_REQUEST";
export const ACCESSES_REQUEST_SUCCEEDED = "ACCESSES_REQUEST_SUCCEEDED";
export const ACCESSES_REQUEST_FAILED = "ACCESSES_REQUEST_FAILED";
